module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/favicon-32x320885cfdcf028b44fb55bde0c6d17637a.png";